var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStopSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333344C3.32065 0.333344 0.333984 3.32001 0.333984 7.00001C0.333984 10.68 3.32065 13.6667 7.00065 13.6667C10.6807 13.6667 13.6673 10.68 13.6673 7.00001C13.6673 3.32001 10.6807 0.333344 7.00065 0.333344ZM10.334 7.66668H3.66732V6.33334H10.334V7.66668Z",
    fill: "#E8132A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopSign);
export default __webpack_public_path__ + "static/media/icon-stop-sign.30ce10419e4688af48669a4fc8a1fdea.svg";
export { ForwardRef as ReactComponent };